// component name
$component: 'zr-quick-filter-container';

.#{$component} {
    display:flex;
    padding-bottom: var(--zr-quick-filter-container-padding-bottom, 16px);
}

.#{$component}__list{
    display: flex;
    overflow-x: scroll;
    gap: var(--zr-quick-filter-container-list-gap, 16px);
    margin-left: var(--zr-quick-filter-container-list-margin-left, 16px);
    padding-bottom: 5px;
    padding-right: 16px;
}

.#{$component}__tag {
    border: 1px solid var(--ci-neutral500);
    color: var(--ci-neutral900);
    align-content: center;
    border-radius: 4px;
    padding: 6px 8px;

    &:focus,
    &:hover {
       background: var(--ci-primary400);
        color: #fff;
        text-decoration: none;
    }
}

@media only screen and (min-width: 768px) {
    .#{$component}{
        align-items: var(--zr-quick-filter-container-desktop-align-items, center);
    }

    .#{$component}__list{
        overflow-x: auto;
        flex-wrap: wrap;
    }
}

